import {
  Disability,
  Guardianship,
  HumanitarianStatus,
  HumanitarianStatusType,
  LivingCircumstances,
  LocationDescription,
} from '@sandtech-hub-monorepo/ehub-client';

export const LevelOfStudySuggestions: string[] = [
  'Some college / No degree',
  'High school diploma',
  "Associate's degree",
  "Bachelor's degree",
  'Postgraduate diploma',
  "Master's degree",
  'Doctorate degree',
];

export const FieldOfStudySuggestions: string[] = [
  'Agriculture, forestry, fisheries and veterinary',
  'Anthropology',
  'Architecture and design',
  'Arts (Literature, Performing and Visual)',
  'Business and Economics (Administration, Commerce, Finance, Accounting and Human Resource)',
  'Education',
  'Engineering (Electrical & Electronic, Manufacturing, Civil, Mechanical, Environmental, Aerospace)',
  'Entertainment and recreation',
  'Environmental studies and forestry',
  'Geography',
  'History, Linguistics and languages',
  'Information Technology and Communication (ICTs), Computer Science, Computer & Software Engineering',
  'Interdisciplinary studies (Ethnic & Culture, Gender & Sexuality and Organisations)',
  'Journalism, media studies and communication',
  'Law',
  'Library and museum studies',
  'Mathematics (Pure, Applied and Statistics)',
  'Medical, Pharmacy & Dental Sciences',
  'Philosophy, Religion Psychology & Sociology',
  'Political science and International Relations',
  'Sciences (Biology, Chemistry, Physics)',
  'Social work, Public Relations, Policy and Administration',
  'Software Engineering',
  'Space sciences & Astronomy',
  'Transportation, Logistics, Supply Chain, Procurement',
  'Other',
];

export const CurrentGuardianshipOptions = {
  [Guardianship.TwoParentHome]: 'Two parent home',
  [Guardianship.SingleParentHome]: 'Single parent home',
  [Guardianship.ParentsDeceased]: 'Parent(s) deceased',
  [Guardianship.Orphaned]: 'Orphaned',
  [Guardianship.Adopted]: 'Adopted',
  [Guardianship.SiblingCaregiver]: 'Sibling caregiver',
  [Guardianship.Refugee]: 'Refugee',
  [Guardianship.Other]: 'Other',
  [Guardianship.NoneOfTheAbove]: 'None of the above',
  [Guardianship.PreferNotToSay]: 'Prefer not to say',
};

export const LocationDescriptionOptions = {
  [LocationDescription.Rural]: 'Rural',
  [LocationDescription.Urban]: 'Urban',
  [LocationDescription.PreferNotToSay]: 'Prefer not to say',
};

export const LivingCircumstancesOptions = {
  [LivingCircumstances.Homeless]: 'Homeless',
  [LivingCircumstances.ShelterTemporaryHousing]:
    'Living in a shelter or temporary housing',
  [LivingCircumstances.RentingUnstableInadequate]:
    'Renting unstable inadequate housing',
  [LivingCircumstances.RentingStableAdequate]:
    'Renting stable and adequate housing',
  [LivingCircumstances.OwnStableAdequate]: 'Own stable and adequate housing',
  [LivingCircumstances.CareFacilityInstitution]:
    'Living in a care facility or institution',
  [LivingCircumstances.Other]: 'Other',
  [LivingCircumstances.PreferNotToSay]: 'Prefer not to say',
};

export const DisabilityOptions = {
  [Disability.None]: 'None',
  [Disability.VisualImpairments]:
    'Visual Impairments: This includes blindness, low vision, and various visual disorders affecting the eyes.',
  [Disability.HearingImpairments]:
    'Hearing Impairments: It involves partial or total inability to hear, ranging from mild to profound deafness.',
  [Disability.MobilityImpairments]:
    "Mobility Impairments: These disabilities affect a person's physical movement or ability to use motor functions, such as paralysis, limb differences, or conditions like cerebral palsy.",
  [Disability.IntellectualDisabilities]:
    'Intellectual Disabilities: These disabilities affect cognitive abilities and adaptive functioning. Conditions like Down syndrome or autism spectrum disorders fall under this category.',
  [Disability.DevelopmentalDisabilities]:
    "Developmental Disabilities: Conditions that impair physical, learning, language, or behavior areas of a person's life, including autism, ADHD, and learning disorders.",
  [Disability.PsychiatricDisabilities]:
    "Psychiatric Disabilities: Mental health conditions that affect a person's thinking, behavior, and mood, such as depression, schizophrenia, and bipolar disorder.",
  [Disability.NeurologicalDisabilities]:
    "Neurological Disabilities: These include conditions affecting the nervous system, such as epilepsy, multiple sclerosis (MS), and Parkinson's disease.",
  [Disability.ChronicHealthConditions]:
    'Chronic Health Conditions: Disabilities resulting from long-term health issues like diabetes, chronic pain, or autoimmune disorders, impacting daily life and functioning.',
  [Disability.SpeechAndLanguageDisabilities]:
    'Speech and Language Disabilities: These affect communication abilities, including stuttering, aphasia, or conditions that hinder speech or language development.',
  [Disability.LearningDisabilities]:
    "Learning Disabilities: Conditions that affect a person's ability to process information and learn efficiently, such as dyslexia, dyscalculia, or auditory processing disorder.",
  [Disability.PreferNotToSay]: 'Prefer not to say',
};

export const HumanitarianStatusOptions = {
  [HumanitarianStatus.Yes]: 'Yes',
  [HumanitarianStatus.No]: 'No',
  [HumanitarianStatus.PreferNotToSay]: 'Prefer not to say',
};

export const HumanitarianStatusTypeOptions = {
  [HumanitarianStatusType.Refugee]:
    'Refugee: someone who is unable or unwilling to return to their country of origin owing to a well-founded fear of being persecuted for reasons of race, religion, nationality, membership of a particular social group, or political opinion',
  [HumanitarianStatusType.AsylumSeeker]:
    'Asylum Seeker: someone who is unable or unwilling to return to their country of origin but whose request for sanctuary has yet to be processed',
  [HumanitarianStatusType.InternallyDisplacedPerson]:
    'Internally Displaced Person: someone who has not crossed an international border to find safety. Unlike refugees, IDPs stay within their own country',
  [HumanitarianStatusType.NotAplicable]: '',
};
